import { AnswerByCategoryPinComponent, AnswerByCategoryPinProps } from '@lessonup/pin-renderer';
import React from 'react';

type AnswerByCategoryPinEditorProps = Omit<AnswerByCategoryPinProps, 'editable'>;

export const AnswerByCategoryPinEditor: React.FC<AnswerByCategoryPinEditorProps> = (props) => {
  return <AnswerByCategoryPinComponent pinSettings={props.pinSettings}>{props.children}</AnswerByCategoryPinComponent>;
};
